module.exports = __webpack_public_path__ + "img/client-1.75fe8c37.webp";